import { useState } from "react";
import { Controller } from "react-hook-form";
import TextField from "../forms/TextField/TextField";
import DatePicker, { validateDate } from "../forms/DateTimePicker/DatePicker";

export default function Register1({ onSubmit, methods }) {
  const {
    handleSubmit,
    control,
    register,
    formState: { errors },
  } = methods;

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  return (
    <div className="font-inter gap-2 flex flex-col justify-center max-w-96">
      <div className="flex flex-col gap-5">
        <h2 className="text-center text-3xl font-poppins font-bold text-gray-900 dark:text-gray-200">
          Create an account
        </h2>
        <form className="flex flex-col gap-2" onSubmit={handleSubmit(onSubmit)}>
          <div className="flex flex-row gap-2">
            {/* First Name */}
            <TextField
              {...register("first_name", {
                required: "First name is required",
              })}
              label="First Name"
              name="first_name"
              type="text"
              placeholder="First Name"
              required
              error={errors.first_name}
              className="w-full"
            />

            {/* Middle Name */}
            <TextField
              {...register("middle_name")}
              label="Middle Name"
              name="middle_name"
              type="text"
              placeholder="Middle Name (Optional)"
              className="w-full"
            />
          </div>

          {/* Last Name */}
          <TextField
            {...register("last_name", {
              required: "Last name is required",
            })}
            label="Last Name"
            name="last_name"
            type="text"
            placeholder="Last Name"
            required
            error={errors.last_name}
          />

          {/* Email */}
          <TextField
            {...register("email", { required: "Email is required" })}
            label="Email"
            name="email"
            type="email"
            placeholder="Enter your email"
            required
            error={errors.email}
          />

          {/* Date of Birth */}
          <Controller
            name="date_of_birth"
            control={control}
            rules={{
              required: "Date of birth is required",
              validate: (value) => validateDate(value, false),
            }}
            render={({ field, fieldState }) => (
              <DatePicker
                label="Date of Birth"
                name={field.name}
                value={field.value}
                onChange={field.onChange}
                onBlur={field.onBlur}
                error={fieldState.error}
                darkMode={true}
                showTime={false}
              />
            )}
          />

          {/* Password */}
          <TextField
            {...register("password", {
              required: "Password is required",
              validate: {
                hasMinLength: (v) => v.length >= 8 || "At least 8 characters",
                hasUppercase: (v) =>
                  /[A-Z]/.test(v) || "Contains uppercase letter",
                hasLowercase: (v) =>
                  /[a-z]/.test(v) || "Contains lowercase letter",
                hasNumber: (v) => /[0-9]/.test(v) || "Contains number",
              },
            })}
            label="Password"
            name="password"
            type="password"
            placeholder="Password"
            required
            error={errors.password}
            showPasswordToggle={true}
            showPassword={showPassword}
            onTogglePassword={() => setShowPassword(!showPassword)}
          />

          {/* Confirm Password */}
          <TextField
            {...register("confirmPassword", {
              required: "Confirm Password is required",
              validate: (value) =>
                value === methods.getValues("password") ||
                "Passwords do not match",
            })}
            label="Confirm Password"
            name="confirmPassword"
            type="password"
            placeholder="Confirm Password"
            required
            error={errors.confirmPassword}
            showPasswordToggle={true}
            showPassword={showConfirmPassword}
            onTogglePassword={() =>
              setShowConfirmPassword(!showConfirmPassword)
            }
          />

          {/* Submit Button */}
          <button
            type="submit"
            className="w-full py-2 bg-blue-950 dark:bg-blue-700 text-white rounded-xl hover:opacity-80"
          >
            Create account
          </button>
        </form>
      </div>
    </div>
  );
}
